import { render, staticRenderFns } from "./MSTeamsRoot.vue?vue&type=template&id=41e8091c"
import script from "./MSTeamsRoot.vue?vue&type=script&lang=js"
export * from "./MSTeamsRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports